import travelerImage from "../assets/image/icons8-traveler-100.svg";
import visaImage from "../assets/image/3057653_media_payment_social_visa_icon-svg.svg";
import airportImage from "../assets/image/airport_100px.svg";
import hotelImage from "../assets/image/hotel_100px.svg";
import theImage from "../assets/image/20211007_120240.png";
import service from "../assets/image/home/Layer8.png";
import tour from "../assets/image/home/Layer7.png";
import reserve from "../assets/image/home/Layer6.png";
import visa from "../assets/image/home/3520661.png";
import airplane from "../assets/image/home/Layer5.png";

export default function Men(props) {
  const theList = [
    {
      text: "تور خارجی",
      image: tour,
    },
    {
      text: "ویزا",
      image: visa,
    },
    {
      text: "بلیط هواپیما",
      image: airplane,
    },
    {
      text: "رزرو هتل",
      image: reserve,
    },
  ];

  return (
    <div className="container">
      <div className="mt-4 fw-bolder fs-4 text-color">خدمات</div>
      <div className="row align-items-center">
        <div className="d-flex flex-wrap col-lg-7 col-md-12 justify-content-around">
          {theList.map((value, index) => (
            <div className="col-12 col-md-6" key={index}>
              <div className="d-flex border border-secondary round m-2 align-items-center service-padding bg-gradient-green">
                <img
                  className="mx-4"
                  src={value.image}
                  style={{ width: "60px", height: "60px" }}
                  alt=""
                />
                <div className="me-4">
                  <div
                    className=" mt-3 fw-bold"
                    style={{ color: "white", fontSize: "18px" }}
                  >
                    {value.text}
                  </div>
                  <div
                    className="size3 font-regular"
                    style={{ color: "white" }}
                  >
                    توضیحات
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className=" col-lg-5 col-md-12 ">
          <img
            className="round w-100"
            src={service}
            // src={theImage}
            style={{ height: "180px" }}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
